/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money.js';

import dateFormat from '@/tools/dateFormat';

export default {
  selection: {
    type: 'selection',
    width: '55',
    prop: 'xiangmucanyuren',
    selectable(row) {
      return row.revokeStatus !== 2;
    }
  },
  createDate: {
    label: '提交日期',
    prop: 'createDate',
    formatter(r, c, v) {
      return dateFormat(v) || '-';
    }
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  xiangmucanyuren: {
    label: '项目参与人',
    prop: 'fullName'
  },
  shoujihao: {
    label: '手机号',
    prop: 'userPhone'
  },
  shoukuanzhanghao: {
    label: '收款账号',
    prop: 'bankNo',
    width: '200px'
  },
  shoukuanfangshi: {
    label: '收款方式',
    prop: 'collectMoneyType',
    render: (h, ctx, r, c) => {
      if (!r[c.property]) return h('span', '-');
      return h('span', ['-', '银行卡', '钱包'][r[c.property]]);
    }
  },
  xiangmumingcheng: {
    label: '项目名称',
    prop: 'projectName'
  },
  renwuyuedu: {
    label: '任务月度',
    prop: 'taskDt'
  },
  gongyingshang: {
    label: '供应商',
    prop: 'supplierName',
    'header-align': 'center',
    width: '150px'
  },

  shijiwanchengrenwuliang: {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  zhongduanjiesuandanjia: {
    label: '终端结算单价',
    prop: 'taskPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  zhongduanjiesuanjine: {
    label: '终端结算金额',
    prop: 'finishSumTaskPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  fuwufeilv: {
    label: '服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      if (!r.supplierName) {
        return '-';
      }
      return (v / 100).toFixed(2) + '%';
    }
  },
  jiesuanzongjia: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  // 订单
  dingdanbianhao: {
    label: '订单编号',
    prop: 'dingdanbianhao'
  },
  dingdanshengchengshijian: {
    label: '订单生成时间',
    prop: 'dingdanshengchengshijian'
  },
  zhifujiezhishijian: {
    label: '支付截止时间',
    prop: 'zhifujiezhishijian'
  },
  bencixudakuanzongjine: {
    label: '本次需打款总金额',
    prop: 'bencixudakuanzongjine'
  },
  zhifuzhuangtai: {
    label: '支付状态',
    prop: 'zhifuzhuangtai'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo'
  }
};
